<template>
  <div class="swiper" ref="swiper">
    <div class="swiper-wrapper">
      <slot />
    </div>
  </div>
</template>

<script>
import Swiper, {
  Autoplay,
  Mousewheel,
  Scrollbar,
  FreeMode,
  Thumbs
} from "swiper"
import BleachSwiper from "./BleachSwiperLib"
import "swiper/scss"
import "swiper/scss/scrollbar"

export default {
  props: {
    options: Object
  },

  data: () => ({
    swiperInstance: null,
    defaultOptions: {
      modules: [Autoplay, Mousewheel, Scrollbar, FreeMode, Thumbs]
    }
  }),

  mounted() {
    this.initSwiper()
  },

  beforeDestroy() {
    this.destroySwiper()
  },

  methods: {
    destroySwiper() {
      if (this.swiperInstance && !this.swiperInstance.destroyed) {
        this.swiperInstance.destroy(true, false)
      }
    },

    resetSwiper() {
      this.destroySwiper()
      this.initSwiper()
    },

    initSwiper() {
      this.swiperInstance = new Swiper(this.$refs.swiper, {
        ...this.defaultOptions,
        ...this.options
      })
      BleachSwiper.bindSwiperEvents(this.swiperInstance, this.$emit.bind(this))
    }
  }
}
</script>

<style></style>
